import { BaseReducer } from '@hobs/utils/baseReducer';
import {
  UNITS,
  UNIT,
  UNITSTATICDATA,
  REMOVE,
  FINANCE,
  WHOCANCONFIRMSOR,
  CLEARFINANCEDATA,
  CANCREATESERVICEREQUEST,
  SUMMARY,
  GETSORPARTY,
  CLEAR_SOR_PARTY
} from '@hobs/constants/sor';

class Sor extends BaseReducer {
  static defaultState = {
    units: [],
    responsiblePerson: [],
    unit: null,
    finance: {},
    whoCanConfirmFsor: {
      usersWhoCanConfirmFsor: []
    },
    canCreateServiceRequest: false,
    sorSummary: {},
    sorParty: {}
  };

  constructor() {
    super(Sor.defaultState);
    this.actionMap = {
      [UNITS.SUCCESS]: this.loadSorUnits,
      [UNIT.SUCCESS]: this.loadSorUnit,
      [UNIT.FAILURE]: this.resetSorUnit,
      [REMOVE.SUCCESS]: this.resetSorUnit,
      [UNIT.RESET]: this.resetSorUnit,
      [UNITSTATICDATA.SUCCESS]: this.loadStaticData,
      [FINANCE.SUCCESS]: this.loadSorFinanceData,
      [WHOCANCONFIRMSOR.SUCCESS]: this.loadWhoCanConfirmFsor,
      [CLEARFINANCEDATA.SUCCESS]: this.clearFinanceData,
      [CANCREATESERVICEREQUEST.SUCCESS]: this.canCreateServiceRequest,
      [SUMMARY.SUCCESS]: this.loadSummaryData,
      [GETSORPARTY.SUCCESS]: this.loadSorParty,
      [CLEAR_SOR_PARTY.SUCCESS]: this.clearSorParty
    };
  }

  loadStaticData = (state, action) => {
    return Object.assign({}, state, {
      responsiblePerson: action.payload.responsiblePerson
    });
  };

  loadSorUnits = (state, action) => {
    return Object.assign({}, state, {
      units: action.payload
    });
  };

  clearFinanceData = state => {
    return Object.assign({}, state, {
      finance: {},
      whoCanConfirmFsor: {}
    });
  };

  loadSorFinanceData = (state, action) => {
    return Object.assign({}, state, {
      finance: action.payload
    });
  };

  loadWhoCanConfirmFsor = (state, action) => {
    return Object.assign({}, state, {
      whoCanConfirmFsor: action.payload
    });
  };

  loadSorUnit = (state, action) => {
    return Object.assign({}, state, {
      unit: action.payload
    });
  };

  resetSorUnit = state => {
    return Object.assign({}, state, {
      unit: null,
      responsiblePerson: []
    });
  };

  canCreateServiceRequest = (state, action) => {
    return Object.assign({}, state, {
      canCreateServiceRequest: action.payload.canCreateServiceRequest
    });
  };

  loadSummaryData = (state, action) => {
    return Object.assign({}, state, {
      sorSummary: action.payload
    });
  };
  loadSorParty = (state, action) => {
    return Object.assign({}, state, {
      sorParty: action.payload
    });
  };
  clearSorParty = state => {
    return Object.assign({}, state, {
      sorParty: {}
    });
  };
}
export default new Sor().reducer;
